var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.a,.b{stroke:#000;}.b{stroke-linecap:round;stroke-linejoin:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15521 -9460)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(15521 9460)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 10,
    cy: 10,
    r: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.111,13h6.667a1.111,1.111,0,0,0,1.111-1.111V8.556a1.111,1.111,0,0,0-1.111-1.111H5.111A1.111,1.111,0,0,0,4,8.556v3.333A1.111,1.111,0,0,0,5.111,13Zm5.556-5.556V5.222a2.222,2.222,0,1,0-4.444,0V7.444Z",
    transform: "translate(15522.5 9461.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9982c4544015e6e6850adc2bd8d03461.svg";
export { ForwardRef as ReactComponent };